export default function GoogleIcon({
  width = '40',
  height = '40',
  ...props
}: React.SVGProps<SVGSVGElement> & { width?: string; height?: string }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#clip0_710_6221)"
        id="g12"
        transform="matrix(1.9975006,0,0,1.9975006,-19.750513,-19.950012)"
      >
        <path
          d="m 29.6,20.2273 c 0,-0.7091 -0.0636,-1.3909 -0.1818,-2.0455 H 20 V 22.05 h 5.3818 c -0.2318,1.25 -0.9363,2.3091 -1.9954,3.0182 v 2.5091 h 3.2318 C 28.5091,25.8364 29.6,23.2727 29.6,20.2273 Z"
          fill="#4285f4"
          id="path4"
        />
        <path
          d="m 20,30 c 2.7,0 4.9636,-0.8955 6.6181,-2.4227 l -3.2318,-2.5091 c -0.8954,0.6 -2.0409,0.9545 -3.3863,0.9545 -2.6046,0 -4.8091,-1.7591 -5.5955,-4.1227 h -3.3409 v 2.5909 C 12.7091,27.7591 16.0909,30 20,30 Z"
          fill="#34a853"
          id="path6"
        />
        <path
          d="m 14.4045,21.9 c -0.2,-0.6 -0.3136,-1.2409 -0.3136,-1.9 0,-0.6591 0.1136,-1.3 0.3136,-1.9 V 15.5091 H 11.0636 C 10.3864,16.8591 10,18.3864 10,20 c 0,1.6136 0.3864,3.1409 1.0636,4.4909 z"
          fill="#fbbc04"
          id="path8"
        />
        <path
          d="m 20,13.9773 c 1.4681,0 2.7863,0.5045 3.8227,1.4954 l 2.8682,-2.8682 C 24.9591,10.9909 22.6954,10 20,10 c -3.9091,0 -7.2909,2.2409 -8.9364,5.5091 L 14.4045,18.1 C 15.1909,15.7364 17.3954,13.9773 20,13.9773 Z"
          fill="#e94235"
          id="path10"
        />
      </g>
    </svg>
  )
}
